export default __webpack_public_path__ + "static/media/movies.efbed039.PNG";